export default "__VITE_ASSET__0bzF8r3c__"